export enum CartStatus {
  /**
   * Collecting items, tender, coupons which intends to add/remove/update operation on the cart
   */
  Itemization = 'Itemization',

  /**
   * Cart Recall status
   */
  Recall = 'Recall',

  /**
   * Get more accurate details on cart e.g. promotion ,restrictions
   */
  Total = 'Total',

  /**
   * Start the process of finalizing cart by tendering the cart
   */
  Tender = 'Tender',

  /**
   * Cart is in closing process
   */
  Finalization = 'Finalization',

  /**
   * cart is closed and read-only
   */
  Closed = 'Closed',

  /**
   * Cart is finalize voiding
   */
  VoidFinalization = 'VoidFinalization',

  /**
   * cart is voided and read-only
   */
  Voided = 'Voided',

  /**
   * cart is finalize suspending
   */
  SuspendFinalization = 'SuspendFinalization',

  /**
   * cart is suspended and read-only
   */
  Suspended = 'Suspended',
}
